import { useGlobalQueries } from '@/hooks/use-global-queries';
import { OneWidgetFaqCached } from './one-widget-faq-cached';
import OneWidgetFaq, { OneWidgetFaqProps } from './one-widget-faq';

export const OneWidgetSelector = (props: OneWidgetFaqProps) => {
    const { getSetting } = useGlobalQueries();
    const humanySettings = getSetting('humany_settings');
    const useCached = humanySettings?.humany_use_cached ?? false;

    return useCached ? <OneWidgetFaqCached {...props} /> : <OneWidgetFaq {...props} />;
};
